module.exports = __webpack_public_path__ + "media/interested_companies/images/star04-55a750b8189a5922c269521945989397.svg";